import { useRoutes } from "routes/useRoutes";
import { useSurveyForm } from "./helpers/useSurveyForm";

export function Buttons() {
  const { goBack } = useRoutes();
  const { isSubmitting } = useSurveyForm();
  return (
    <div className="d-flex my-3 justify-content-between">
      <button
        className="btn btn-outline-primary"
        disabled={isSubmitting}
        onClick={(e) => {
          e.preventDefault();
          goBack();
        }}
      >
        Cancel
      </button>
      <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
        Save & Close
        {isSubmitting && (
          <span
            className="spinner-border spinner-border-sm ms-1"
            role="status"
            aria-hidden="true"
          ></span>
        )}
      </button>
    </div>
  );
}
